import React, { useEffect, useState } from 'react';
// import { useMutation } from '@apollo/client';
import SideDrawer from '../../../../components/SideDrawer';
import { GET_ALL_STAFF } from '../../../../graphql/admin_queries';
import useCustomQuery from '../../../../network/useCustomQuery';
import Styles from './AddMember.module.scss';
import GroupMemebers from '../GroupMemebers';
import StyledButton from '../../../../components/StyledButton';
import EmptyPageLoader from '../../../../components/EmptyPageLoader';
// import { ADD_MEMBERS_TO_ROLE } from '../../../../graphql/admin_mutations';

interface IAddMember{
  onClose:any;
  activeRoleId:any;
  selectedMembers:any;
  selectedNewAddedMember:any;
}
const AddMember = ({
  onClose, activeRoleId, selectedMembers, selectedNewAddedMember,
}:IAddMember) => {
  const [newAddedMember, setNewAddedMember] = useState([]);
  const [getAllStaff, getAllStaffLoading, getStaffs] = useCustomQuery({
    query: GET_ALL_STAFF,
    onError: () => {},
    onData: () => {},
  });

  const [memebers, setMemebers] = useState(null);
  const fetchStaffs = () => {
    getAllStaff({
      variables: {
        roleId: '',
        limit: 100,
      },
    });
  };

  useEffect(() => {
    fetchStaffs();
  }, []);

  const reformatMemebersToGroup = () => {
    // eslint-disable-next-line max-len
    const reformattedData = getStaffs?.getStaffs?.data?.rows?.reduce((acc, item) => {
      // Check if the group already exists in the accumulator
      if (item?.role?.name && !acc[item?.role?.name]) {
        // If not, create a new group with an empty array
        acc[item?.role?.name] = {
          group: item?.role?.name?.split('-').join(' '),
          members: [],
        };
      }
      // Push the item to the corresponding group
      acc[item?.role?.name]?.members.push({
        ...item,
        checkMemeber: item?.role?.id === activeRoleId?.id,
      });

      return acc;
    }, {});

    const dataValue = Object.values(reformattedData);

    setMemebers(dataValue);
  };

  useEffect(() => {
    if (getStaffs?.getStaffs?.data) {
      reformatMemebersToGroup();
    }
  }, [getStaffs]);

  const getNewMemberAddedToTeam = (newMember:any) => {
    if (newMember?.checkMemeber) {
      setNewAddedMember((prev:any) => [...prev, newMember]);
    } else {
      // eslint-disable-next-line max-len
      const removeNewMember = newAddedMember?.filter((removeMember:any) => removeMember?.id !== newMember?.id);
      setNewAddedMember(removeNewMember);
    }
  };

  const handleUpdate = (id:string, group:string) => {
    const findSelectedValue = memebers?.find((list:any) => list?.group === group);

    if (findSelectedValue) {
      const checkThroughPermissions = memebers?.map((details) => {
        // eslint-disable-next-line max-len
        const updatedData = details?.group === findSelectedValue?.group ? {
          group: details?.group,
          members: details?.members?.map((member) => {
            if (member?.id === id) {
              getNewMemberAddedToTeam({ ...member, checkMemeber: !member?.checkMemeber });
              return { ...member, checkMemeber: !member?.checkMemeber };
            }

            return { ...member };
          }),
        } : details;

        return updatedData;
      });

      setMemebers(checkThroughPermissions);
    }
  };

  const handleSubmit = async () => {
    const newData = [];
    // eslint-disable-next-line no-undef
    memebers?.map((list:any) => {
      const getMemebers = list?.members;
      // eslint-disable-next-line max-len
      return getMemebers?.filter((data:any) => data?.checkMemeber === true && newData.push(data));
    });
    selectedMembers(newData);
    selectedNewAddedMember(newAddedMember);
  };

  return (
    <div className={Styles.wrapper}>
      <SideDrawer onClose={onClose} title="Add member" subtitle="Description of what users should do here.">
        {
          getAllStaffLoading ? <EmptyPageLoader /> : (
            <div className={Styles.wrapper__container}>
              {' '}
              {
                // eslint-disable-next-line max-len
                memebers && <GroupMemebers members={memebers} handleUpdateCheckStatus={(id:string, group:string) => handleUpdate(id, group)} />
              }

              <div className={Styles.wrapper__btn}>
                <StyledButton width="100%" name="Add Member" backgroundColor="rgba(89, 65, 169, 1)" borderRadius="4px" border="none" padding="16px" color="white" fontWeight="600" onClick={handleSubmit} disabled={!newAddedMember?.length} />
              </div>

            </div>
          )
        }

      </SideDrawer>
    </div>
  );
};

export default AddMember;
